import { ACOES_AUDITORIA } from "../../lib/auditoria/tipos";

/*
 * Controles de filtro da trilha de auditoria (FE-5 CP-C — LEITURA).
 *
 * Componente CONTROLADO e SEM ESTADO PRÓPRIO: recebe os valores correntes
 * (`acao`/`usuario_id`/`data_de`/`data_ate`/`recurso_prefixo`) e um callback
 * `aoMudarFiltro(campo, valor)`. O estado mora na PÁGINA (`Trilha.tsx`), que ao
 * receber a mudança reseta o `offset` e limpa a seleção.
 *
 * REGRA DE VAZIO: o select de ação tem a opção "Todas" (value `""`); os campos de
 * texto/data podem ficar vazios. A página é quem decide NÃO promover string vazia
 * a filtro ativo (a camada de `api` já omite vazios da query). Aqui só refletimos
 * o valor corrente como `""` quando o filtro está ausente.
 *
 * `aoLimpar` zera todos os filtros opcionais de uma vez.
 *
 * O vocabulário de ação vem de `ACOES_AUDITORIA` (fonte única do enum do backend)
 * — nunca strings soltas.
 */

/** Campos opcionais que este componente edita (limit/offset são da página). */
export type CampoFiltro =
  | "acao"
  | "usuario_id"
  | "data_de"
  | "data_ate"
  | "recurso_prefixo";

interface FiltrosTrilhaProps {
  acao: string;
  usuarioId: string;
  dataDe: string;
  dataAte: string;
  recursoPrefixo: string;
  /** Notifica a página de uma mudança em um campo de filtro. */
  aoMudarFiltro: (campo: CampoFiltro, valor: string) => void;
  /** Limpa todos os filtros opcionais. */
  aoLimpar: () => void;
}

export function FiltrosTrilha({
  acao,
  usuarioId,
  dataDe,
  dataAte,
  recursoPrefixo,
  aoMudarFiltro,
  aoLimpar,
}: FiltrosTrilhaProps): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end gap-4">
        <label className="flex flex-col gap-1 font-corpo text-base text-off-black">
          <span className="font-subtitulo">Ação</span>
          <select
            value={acao}
            onChange={(evento) => aoMudarFiltro("acao", evento.target.value)}
            className="rounded-md border border-platinum bg-snow px-2 py-1 text-off-black"
          >
            <option value="">Todas</option>
            {ACOES_AUDITORIA.map((valor) => (
              <option key={valor} value={valor}>
                {valor}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col gap-1 font-corpo text-base text-off-black">
          <span className="font-subtitulo">Usuário (id)</span>
          <input
            type="text"
            value={usuarioId}
            onChange={(evento) =>
              aoMudarFiltro("usuario_id", evento.target.value)
            }
            className="rounded-md border border-platinum bg-snow px-2 py-1 text-off-black"
          />
        </label>

        <label className="flex flex-col gap-1 font-corpo text-base text-off-black">
          <span className="font-subtitulo">De (data)</span>
          <input
            type="date"
            value={dataDe}
            onChange={(evento) =>
              aoMudarFiltro("data_de", evento.target.value)
            }
            className="rounded-md border border-platinum bg-snow px-2 py-1 text-off-black"
          />
        </label>

        <label className="flex flex-col gap-1 font-corpo text-base text-off-black">
          <span className="font-subtitulo">Até (data)</span>
          <input
            type="date"
            value={dataAte}
            onChange={(evento) =>
              aoMudarFiltro("data_ate", evento.target.value)
            }
            className="rounded-md border border-platinum bg-snow px-2 py-1 text-off-black"
          />
        </label>

        <label className="flex flex-col gap-1 font-corpo text-base text-off-black">
          <span className="font-subtitulo">Recurso (prefixo)</span>
          <input
            type="text"
            value={recursoPrefixo}
            onChange={(evento) =>
              aoMudarFiltro("recurso_prefixo", evento.target.value)
            }
            className="rounded-md border border-platinum bg-snow px-2 py-1 text-off-black"
          />
        </label>
      </div>

      <button
        type="button"
        onClick={aoLimpar}
        className="self-start rounded-md border border-platinum bg-platinum px-3 py-1 font-subtitulo text-off-black hover:text-flame"
      >
        Limpar filtros
      </button>
    </div>
  );
}
